import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = { class: "grid grid-cols-3 font-regular gap-4" }
const _hoisted_3 = {
  key: 0,
  class: "text-darkGray-2 col-span-full"
}
const _hoisted_4 = {
  key: 1,
  class: "text-darkGray-2 col-span-full"
}
const _hoisted_5 = ["tag"]
const _hoisted_6 = { class: "mr-auto" }
const _hoisted_7 = { class: "flex gap-2 text-darkGray-2 text-lg" }
const _hoisted_8 = ["onClick", "isEditing"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 1 }

import { computed, ref, watch, markRaw } from "vue";
import { defineEmits, defineProps } from "@vue/runtime-core";
import { useStore } from "vuex";
import ElementEditorImport from "@/features/shared/components/form/ElementEditor.vue";
import ElementGroupEditorImport from "@/features/shared/components/form/ElementGroupEditor.vue";

// editView håller en komponentdefinition som tilldelas till en
// FormItemModel som lever i reactive store-state. markRaw hindrar
// Vue från att göra komponenten reactive.
import { FormBuilder2 } from "@/models/FormBuilder2";
import { FormItemModel } from "@/models/CheckboxGroup";
import { DynamicProperty, SelectedItems } from "../../models/dtos";
import { ToastNotification } from "@/models/ToastNotification";
import draggable from "vuedraggable";


export default /*@__PURE__*/_defineComponent({
  __name: 'FormInputList',
  props: {
  selectedItems: {
    type: Object as () => SelectedItems,
    required: false,
  },
  // Deklareras endast för att undvika "Extraneous non-props
  // attributes"-varning när FormInputList renderas via dynamisk
  // <component :is>-binding i PositionFormBuilder + FormTemplateCreator
  // (fragment-root → attrs ärvs inte automatiskt). FormInputList
  // använder dem inte själv.
  positionType: {
    type: String,
    required: false,
  },
  positionTypeId: {
    type: Number,
    required: false,
  },
},
  emits: ["change", "remove", "select", "orderChange"],
  setup(__props, { emit: __emit }) {

const ElementEditor = markRaw(ElementEditorImport);
const ElementGroupEditor = markRaw(ElementGroupEditorImport);
const emit = __emit;
const elementOrderChanged = (e: any) => {
  if (model.value?.Items) {
    for (let i = 0; i < model.value.Items.length; i++) {
      model.value.Items[i].item.order = i;
    }
    emit("orderChange", model.value);
  }
};

const props = __props;
const store = useStore();
const tag = ref(0);
const isVisible = ref(true);

watch(store.getters.form, () => {
  tag.value++;

  isVisible.value = !isVisible.value;
  isVisible.value = !isVisible.value;
});

const drag = ref(false);

const model = computed(() => {
  return store.getters['formbuilder/form'] ? (store.getters['formbuilder/form'] as FormBuilder2) : null;
});

const iconMap: { [key: string]: string } = {
  form_ssn: "fa-brands fa-odnoklassniki",
  form_firstname: "fa-solid fa-signature",
  form_surname: "fa-solid fa-signature",
  form_address: "fa-regular fa-address-book",
  form_zipcode: "fa-regular fa-address-book",
  form_city: "fa-regular fa-address-book",
  form_email: "fa-regular fa-envelope",
  form_mobilePhone: "fa-solid fa-phone",
  form_homePhone: "fa-solid fa-phone",
  form_additional: "fa-solid fa-info",
  form_textarea_: "fa-solid fa-align-justify",
  form_text_: "fa-solid fa-font",
  customform_: "fa-regular fa-square-check",
  radio: "fa-regular fa-circle-dot",
  form_referer: "fa-regular fa-square-check",
  form_agreement: "fa-regular fa-handshake",
  form_file: "fa-solid fa-file-import",
  driverlicenseform: "fa-solid fa-id-card",
  licensetodriveform: "fa-solid fa-id-card",
  requirementsform: "fa-solid fa-square-check",
  summerpositionchoicesform: "fa-regular fa-pen-to-square",
  summerpositionperiodsform: "fa-regular fa-calendar-days",
  summerperiodsform: "fa-regular fa-calendar-days",
  form_linkedInUrl: "fa-brands fa-linkedin",
  template_standard: "fa-solid fa-star",
};

const getClassForElement = (key: any) => {
  const matchedKeys = Object.keys(iconMap).filter((mapKey) =>
    key.startsWith(mapKey)
  );
  return matchedKeys.length > 0 ? iconMap[matchedKeys[0]] : "";
};

const editItem = ref({} as FormItemModel);
const form = ref({} as FormBuilder2);
const isEdit = ref(false);
function editInput(item: FormItemModel, event: any) {
  if (item.id.name === "InputText2") item.editView = ElementEditor;
  if (item.id.name === "InputCheckbox2") item.editView = ElementEditor;
  if (item.id.name === "InputCheckboxGroup2") {
    item.editView = ElementGroupEditor;
  }

  editItem.value = item;

  isEdit.value = !isEdit.value;
  store.dispatch("setFormView", item);
  emit("change", item);
}

function onEnd(e: any) {
  model.value?.setOrder();
}

function onRemove(e: DynamicProperty) {
  if (model.value) {
    model.value.removeByProperty(e);
  }
}

function removeInput(item) {
  store.dispatch(
    "addNotification",
    new ToastNotification("success", "Fältet har tagits bort")
  );
  emit("select", item.key);
  if (model.value) {
    model.value.removeByProperty(item);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isEdit.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("nav", _hoisted_2, [
            (!model.value?.Items || model.value.Items.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Här var det tomt. Lägg till minst ett fält för att kunna redigera det. "))
              : (_openBlock(), _createElementBlock("p", _hoisted_4, " Här kan du redigera och ta bort fält i formuläret. Ta tag i ett fält för att flytta det. ")),
            (isVisible.value && model.value?.Items && model.value.Items.length > 0)
              ? (_openBlock(), _createBlock(_unref(draggable), {
                  key: 2,
                  onChange: elementOrderChanged,
                  onStart: _cache[0] || (_cache[0] = ($event: any) => (drag.value = true)),
                  onEnd: _cache[1] || (_cache[1] = ($event: any) => (drag.value = false)),
                  modelValue: model.value.Items,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.value.Items) = $event)),
                  group: "people",
                  class: "col-span-full grid grid-cols-2 font-regular gap-4",
                  animation: 200,
                  sort: true,
                  "item-key": "element.item.id.name"
                }, {
                  item: _withCtx(({ element }) => [
                    (_openBlock(), _createElementBlock("div", {
                      tag: tag.value,
                      href: "#",
                      class: "flex gap-2 items-center justify-between px-6 py-3 bg-blue-4 text-sm rounded-lg cursor-move",
                      key: element.item.id
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["text-darkGray-3 mr-2 text-[16px]", getClassForElement(element.item.key)])
                      }, null, 2),
                      _createElementVNode("p", _hoisted_6, _toDisplayString(element.item.label), 1),
                      _createElementVNode("div", _hoisted_7, [
                        (element.item.label !== 'Villkor')
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              onClick: ($event: any) => (editInput(element, $event)),
                              title: "Redigera",
                              class: "fas cursor-pointer fa-edit hover:text-blue-2",
                              isEditing: isEdit.value
                            }, null, 8, _hoisted_8))
                          : _createCommentVNode("", true),
                        (element.item.label !== 'Villkor')
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 1,
                              onClick: ($event: any) => (removeInput(element.item)),
                              title: "Ta bort",
                              class: "fas cursor-pointer fa-trash-alt hover:text-red-2"
                            }, null, 8, _hoisted_9))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_5))
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (isEdit.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_unref(ElementEditor), {
            onRemove: removeInput,
            onIsEdit: _cache[3] || (_cache[3] = ($event: any) => (isEdit.value = false)),
            model: editItem.value.item
          }, null, 8, ["model"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})